import React, { useState } from 'react';
import V4Tabs from './V4Tabs';
import { API_BASE_URL } from '../../config';
import { useAuth } from '../../contexts/AuthContext';

const DocumentsSearchV4 = () => {
  const { getAuthHeaders } = useAuth();
  const [query, setQuery] = useState('');
  const [fileIds, setFileIds] = useState('');
  const [fileNames, setFileNames] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [tookMs, setTookMs] = useState(null);
  const [diag, setDiag] = useState(null);

  const runSearch = async () => {
    const params = new URLSearchParams({ query, file_ids: fileIds, file_names: fileNames, top_k: '8' });
    const res = await fetch(`${API_BASE_URL}/api/v4/documents/search?${params.toString()}`, { headers: { ...getAuthHeaders() } });
    const data = await res.json();
    const matches = Array.isArray(data?.results?.matches) ? data.results.matches : [];
    setSearchResults(matches);
    setTookMs(typeof data.took_ms === 'number' ? data.took_ms : null);
  };

  const loadDiagnostics = async () => {
    const res = await fetch(`${API_BASE_URL}/api/v4/documents/pinecone/diagnostics`, { headers: { ...getAuthHeaders() } });
    const data = await res.json();
    setDiag(data);
  };

  return (
    <div className="container py-4">
      <h3 className="mb-3">Documents v4</h3>
      <V4Tabs />
      <div className="card">
        <div className="card-body">
          <h6 className="mb-3">Pinecone Search</h6>
          <div className="row g-2 mb-3">
            <div className="col-md-6"><input className="form-control" placeholder="Query" value={query} onChange={(e) => setQuery(e.target.value)} /></div>
            <div className="col-md-3"><input className="form-control" placeholder="File IDs (csv)" value={fileIds} onChange={(e) => setFileIds(e.target.value)} /></div>
            <div className="col-md-3"><input className="form-control" placeholder="File names (csv)" value={fileNames} onChange={(e) => setFileNames(e.target.value)} /></div>
          </div>
          <button className="btn btn-outline-primary" onClick={runSearch}>Search</button>
          <button className="btn btn-outline-info ms-2" onClick={loadDiagnostics}>Diagnostics</button>

          <div className="mt-3">
            {typeof tookMs === 'number' && <div className="text-muted small mb-2">Results in {tookMs} ms</div>}
            {searchResults.map((r, idx) => {
              const meta = r?.metadata || {};
              const title = meta.original_filename || meta.path || r.id;
              const snippet = r?.chunk || '';
              return (
                <div key={idx} className="border rounded p-2 mb-2">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="fw-semibold">{title}</div>
                    <div className="text-muted small">score: {typeof r.score === 'number' ? r.score.toFixed(3) : '-'}</div>
                  </div>
                  {snippet ? (
                    <div className="mt-1 small" style={{ whiteSpace: 'pre-wrap' }}>{snippet}</div>
                  ) : (
                    <div className="mt-1 small text-muted">No snippet available</div>
                  )}
                </div>
              );
            })}

            {diag && (
              <div className="accordion mt-3" id="diagAccordionV4">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingDiagV4">
                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDiagV4" aria-expanded="true" aria-controls="collapseDiagV4">
                      Pinecone Diagnostics
                    </button>
                  </h2>
                  <div id="collapseDiagV4" className="accordion-collapse collapse show" aria-labelledby="headingDiagV4" data-bs-parent="#diagAccordionV4">
                    <div className="accordion-body">
                      <pre className="mb-0 small">{JSON.stringify(diag, null, 2)}</pre>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsSearchV4;


